<template>
  <section class="container-wrapper">
    <div class="container-box">
      <el-divider content-position="left">主体信息</el-divider>
      <div class="container-form">
        <el-form
          ref="ruleForm"
          :model="formData"
          :rules="rules"
          label-width="110px"
        >
          <div class="form_wrapper">
            <div class="form_item_wrapper">
              <div class="form_item set-width">
                <el-form-item label="协议编号:">
                  {{ formData.agreementCode }}
                </el-form-item>
              </div>
              <div class="form_item form_item_r">
                <el-form-item label="协议名称:" prop="agreementName">
                  {{ formData.agreementName }}
                </el-form-item>
              </div>
            </div>
            <div class="form_item_wrapper">
              <div class="form_item set-width">
                <el-form-item label="协议甲方企业:" prop="firstCompanyId">
                  {{ formData.firstCompanyName }}
                </el-form-item>
              </div>
              <div class="form_item form_item_r">
                <el-form-item label="协议乙方企业:" prop="secondCompanyId">
                  {{ formData.secondCompanyName }}
                </el-form-item>
              </div>
            </div>
            <div class="form_item_wrapper">
              <div class="form_item set-width">
                <el-form-item label="协议发起方:" prop="firstCompanyId"
                  >易派客电子商务有限公司</el-form-item
                >
              </div>
              <div class="form_item form_item_r">
                <el-form-item label="乙方类型:" prop="secondCompanyType">
                  <el-select
                    v-model="formData.secondCompanyType"
                    placeholder="请选择乙方类型"
                    style="width: 220px"
                  >
                    <el-option
                      v-for="(item, index) in secondCompany.typeList"
                      :key="index"
                      :label="item.name"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>

            <div class="form_item_wrapper">
              <div class="form_item set-width">
                <el-form-item label="协议有效时间:" prop="startDate">
                  <div class="date-choose">
                    <el-date-picker
                      v-model="formData.startDate"
                      type="date"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="开始日期"
                    >
                    </el-date-picker>
                    <div style="width: 10px"></div>
                    <el-date-picker
                      v-model="formData.endDate"
                      :disabled="disabled"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="结束日期"
                    >
                    </el-date-picker>
                  </div>
                  <div class="show-tip">
                    协议有效时间为1年，只选择开始日期即可
                  </div>
                </el-form-item>
              </div>
              <div class="form_item form_item_r">
                <el-form-item label="服务费率:" prop="serviceRate">
                  {{ formData.serviceRate }}%
                </el-form-item>
              </div>
            </div>
            <div class="form_item_wrapper">
              <div class="form_item set-width">
                <el-form-item label="协议状态:">{{
                  formatStatus(formData.agreementStatus)
                }}</el-form-item>
              </div>
              <div class="form_item form_item_r">
                <el-form-item label="联系人:" prop="contact">
                  <el-input
                    v-model.trim="formData.contact"
                    :maxlength="50"
                    placeholder="请输入联系人"
                    style="width: 220px"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="form_item_wrapper">
              <div class="form_item set-width">
                <el-form-item label="联系方式:" prop="telephone">
                  <el-input
                    v-model.trim="formData.telephone"
                    :maxlength="50"
                    placeholder="请输入联系方式"
                    style="width: 220px"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="form_item form_item_r">
                <el-form-item label="审核状态:">
                  <div
                    class="ellipsis"
                    :class="{ danger: [3, 5].includes(formData.auditStatus) }"
                  >
                    {{ formatAuditStatus(formData.auditStatus) }}
                  </div>
                </el-form-item>
              </div>
            </div>
            <div class="flex tree_wrapper">
              <div class="form_item form_location">
                <el-form-item label="协议物料分类:" required>
                  <div class="tree_box">
                    <p>可选的物料分类</p>
                    <div class="search">
                      <el-input
                        v-model="filterText"
                        class="searchText"
                        placeholder="输入关键字进行过滤"
                        @keyup.enter.native="handleSearch"
                      ></el-input>
                      <el-button type="primary" plain @click="handleSearch"
                        >搜 索</el-button
                      >
                    </div>
                    <el-tree
                      ref="eltree"
                      class="tree scrollbar-page"
                      :filter-node-method="filterNode"
                      :data="treeData"
                      show-checkbox
                      node-key="categoryId"
                      :default-expanded-keys="defaultChecked"
                      :default-checked-keys="defaultChecked"
                      :props="defaultProps"
                      @click="handleSelect"
                      @check-change="handleSelect"
                    >
                    </el-tree>
                  </div>
                </el-form-item>
              </div>
              <div class="form_icon">
                <span @click="handleSelect"
                  ><i class="el-icon-arrow-right"></i
                  ><i class="el-icon-arrow-right"></i
                ></span>
              </div>
              <div class="form_item form_item_r form_location">
                <el-form-item>
                  <div class="tree_box">
                    <p>已选的物料分类</p>
                    <ul class="selected scrollbar-page">
                      <li v-for="(item, index) in selectedData" :key="index">
                        <span class="text">{{ item.categoryName }}</span>
                        <span
                          class="icon"
                          @click="deleteRow(index, selectedData)"
                        >
                          <i class="el-icon-close"></i
                        ></span>
                      </li>
                    </ul>
                  </div>
                </el-form-item>
              </div>
            </div>

            <div class="form_item_wrapper">
              <el-form-item label="协议附件:" prop="fileName">
                <div class="flex line_box">
                  <el-input
                    v-model.trim="formData.fileName"
                    placeholder="填写附件名称"
                    :maxlength="50"
                    style="width: 220px"
                  ></el-input>

                  <el-upload
                    ref="upload"
                    class="upload-demo"
                    :action="uploadAction"
                    :headers="headers"
                    :on-success="handleSuccess"
                    :before-upload="beforeUpload"
                    :on-error="handleError"
                    :on-change="fileChange"
                    :data="uploadData"
                    :on-progress="uploadProcess"
                    :show-file-list="false"
                    :accept="acceptFileType"
                    :file-list="fileList"
                    :auto-upload="false"
                  >
                    <el-input
                      slot="trigger"
                      style="width: 200px; margin-left: 20px; height: 28px"
                      :disabled="true"
                      :placeholder="placeholderData.selectedFileName"
                    >
                      <el-button
                        slot="append"
                        class="upload_btn"
                        type="info"
                        icon="el-icon-search"
                      ></el-button>
                    </el-input>
                    <el-button
                      type="primary"
                      style="margin-left: 20px"
                      @click="submitUpload"
                      >点击上传</el-button
                    >
                    <div slot="tip" class="el-upload__tip">
                      <el-progress
                        v-if="progressFlag"
                        :percentage="loadProgress"
                      ></el-progress>
                    </div>
                  </el-upload>
                  <div>
                    <el-tooltip effect="dark" placement="top">
                      <p class="box_tips">
                        <i class="el-icon-question"></i>上传文件说明
                      </p>
                      <template slot="content">
                        <p class="tips_content">
                          <i class="el-icon-warning"></i>上传文件要求:
                        </p>
                        <p class="tips_content">
                          格式支持Word、Excel、PDF，<br />单次上传最大限制10M！
                        </p>
                      </template>
                    </el-tooltip>
                  </div>
                  <p class="doc_list" @click="accessoryVisiblel = true">
                    已上传附件列表
                  </p>
                </div>
              </el-form-item>
            </div>
          </div>
          <div class="form_bottom">
            <el-button type="primary" plain @click="goback()">取 消</el-button>
            <el-button type="primary" @click="handleSubmit">确 认</el-button>
          </div>
        </el-form>
      </div>
    </div>
    <!-- 附件列表 -->
    <e-dialog
      :dialog-title="'附件列表'"
      :center-dialog-visible="accessoryVisiblel"
      :popup-width="'700px'"
      :close-btn="true"
      @updateVisible="accessoryResetPopupData"
      @resetPopupData="accessoryResetPopupData"
    >
      <div>
        <tableList
          style="margin-top: 10px"
          :table-data="fileList"
          :table-label="accessoryTableLabel"
        >
          <template #operation="tData">
            <el-button
              type="text"
              @click="handleDownloadAccessory(tData.scope.row)"
              >查看附件</el-button
            >
          </template>
        </tableList>
      </div>
    </e-dialog>
  </section>
</template>

<script>
import userApi from '../../api/user/index';
import productApi from '../../api/product/index';
import agreementApi from '../../api/agreement/index';
import { epecToken } from '../../utils/globalData';
import { mobilePhone } from '../../utils/validate';
import eDialog from '../../components/common/e-dialog';
import tableList from '../../components/common/e-table-list';
import bus from '@/components/common/bus';

export default {
  components: {
    eDialog,
    tableList,
  },
  data() {
    const checkServiceRate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入订单提成比例'));
      }
      if (value > 0 && value < 100) {
        callback();
      } else {
        callback(new Error('比例大小0-100'));
      }
    };
    const checkFileName = (rule, value, callback) => {
      if (rule.required) {
        if (!value) {
          return callback(new Error('请输入附件名称'));
        }
        if (!this.selectedFile.size) {
          return callback(new Error('请选择附件'));
        }
        callback();
      } else {
        callback();
      }
    };
    return {
      agreementId: '',
      uploadAction: '',
      headers: epecToken,
      rules: {
        agreementName: [
          { required: true, message: '请填写协议名称', trigger: 'blur' },
        ],
        firstCompanyId: [
          { required: true, message: '请选择甲方企业', trigger: 'change' },
        ],
        secondCompanyId: [
          { required: true, message: '请选择乙方企业', trigger: 'change' },
        ],
        secondCompanySource: [
          { required: true, message: '请选择乙方来源', trigger: 'change' },
        ],
        secondCompanyType: [
          { required: true, message: '请选择乙方类型', trigger: 'change' },
        ],
        startDate: [
          { required: true, message: '请选择协议有效时间', trigger: 'change' },
        ],
        serviceRate: [
          { required: true, validator: checkServiceRate, trigger: 'blur' },
        ],
        selectedData: [
          { required: true, message: '请选择协议物料分类', trigger: 'change' },
        ],
        fileName: [
          { required: true, validator: checkFileName, trigger: 'blur' },
        ],
        contact: [{ required: true, message: '请填写联系人', trigger: 'blur' }],
        telephone: [
          {
            required: true,
            validator: mobilePhone,
            trigger: ['blur', 'change'],
          },
        ],
      },
      disabled: true,
      formData: {
        agreementCode: '',
        agreementName: '',
        attachments: [],
        categories: [],
        startDate: '',
        endDate: '',
        firstCompanyId: '',
        firstCompanyName: '',
        secondCompanyId: '',
        secondCompanyName: '',
        secondCompanySource: '',
        secondCompanyType: '',
        serviceRate: '',
        fileName: '',
        contact: '',
        telephone: '',
      },
      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'categoryName',
      },
      defaultChecked: [],
      selectedData: [],
      fileList: [],
      uploadData: { name: '' },
      firstCompany: {
        loading: false,
        list: [],
      },
      secondCompany: {
        loading: false,
        list: [],
        typeList: [
          {
            name: '生产商',
            value: 0,
          },
          {
            name: '流通商',
            value: 1,
          },
        ], // 乙方类型 0-生产商 1-流通商 2-代理商
        sourceList: [
          {
            name: '框架协议',
            value: 0,
          },
          {
            name: '系统集成',
            value: 1,
          },
          {
            name: '平台自注册',
            value: 2,
          },
        ], // 乙方来源 0-框架协议 1-系统集成 2-平台自注册
      },
      accessoryVisiblel: false, // 附件列表弹框
      accessoryTableLabel: [
        {
          label: '附件名称',
          param: 'attachmentName',
          align: 'left',
        },
        {
          label: '上传时间',
          param: 'uploadTime',
          align: 'center',
        },
        {
          label: '操作',
          align: 'center',
          slot: 'operation',
          fixed: 'right',
        },
      ],
      uploadType: 'before',
      selectedFile: {
        size: 0,
      },
      handleEditStatus: false,
      selectedFileList: [],
      loadProgress: 0,
      progressFlag: false,

      acceptFileType: '.pdf,.xls,.xlsx,.doc,.docx',
      placeholderData: {
        selectedFileName: '浏览本地文件',
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 365);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      agreementStatus: '',
    };
  },
  computed: {},
  watch: {
    'formData.startDate': function (val) {
      console.log(val, 'sssssssssss');
      const end = new Date();
      const start = new Date(val);
      end.setTime(start.getTime() + 3600 * 1000 * 24 * 365);
      let month = String(end.getMonth() + 1);
      if (month.length === 1) {
        month = `0${month}`;
      }
      let showDate = String(end.getDate());
      if (showDate.length === 1) {
        showDate = `0${showDate}`;
      }
      this.formData.endDate = `${end.getFullYear()}-${month}-${showDate}`;
    },
  },
  created() {
    this.agreementId = this.$route.query.agreementId;
    this.pageType = 'edit';
    this.getAgreementInfo();
    this.uploadAction = productApi.fileUploadForShareAgreementFile();
  },
  methods: {
    onlyNumber() {
      this.formData.serviceRate = this.onlyNumOnePoint(
        this.formData.serviceRate
      );
    },
    onlyNumOnePoint(number_only) {
      // 先把非数字的都替换掉，除了数字和小数点
      number_only = number_only.replace(/[^\d.]/g, '');
      // 必须保证第一个为数字而不是小数点
      number_only = number_only.replace(/^\./g, '');
      // 保证只有出现一个小数点而没有多个小数点
      number_only = number_only.replace(/\.{2,}/g, '.');
      // 保证小数点只出现一次，而不能出现两次以上
      number_only = number_only
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.');
      // 保证只能输入两个小数
      number_only = number_only.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      return number_only;
    },
    handleSelect() {
      this.selectedData = [];
      const list = this.$refs.eltree.getCheckedNodes();
      list.forEach((item) => {
        const arr = [];
        this.selectedData.forEach((item1) => {
          arr.push(item1.categoryId);
        });
        const isIn = arr.includes(item.categoryId);
        if (!isIn && item.isLeaf == 1) {
          this.selectedData.push(item);
        }
      });
    },
    deleteRow(index, rows) {
      rows.splice(index, 1);
      const checkData = this.selectedData.map((item) => item.categoryId);
      this.$refs.eltree.setCheckedKeys(checkData);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.categoryName.indexOf(value) !== -1;
    },
    handleSearch() {
      this.$refs.eltree.filter(this.filterText);
    },
    formatStatus(val) {
      let res = '';
      switch (val) {
        case 0:
          res = '待维护商品';
          break;
        case 1:
          res = '待生效';
          break;
        case 2:
          res = '已生效';
          break;
        case 3:
          res = '已失效';
          break;
        case 4:
          res = '待审核商品';
          break;
        case 5:
          res = '已停用';
          break;
        case 6:
          res = '待平台审核';
          break;
        case 7:
          res = '审核拒绝';
          break;
      }
      return res;
    },
    // 审核状态
    formatAuditStatus(val) {
      let str = null;
      switch (val) {
        case 1:
          str = '待初审';
          break;
        case 2:
          str = '审核通过';
          break;
        case 3:
          str = '初审拒绝';
          break;
        case 4:
          str = '待复审';
          break;
        case 5:
          str = '复审拒绝';
          break;
        default:
          str = '';
      }
      return str;
    },
    // 获取甲方企业
    async queryInnerCompany(val) {
      const params = {
        companyName: val,
        pageNum: 1,
        pageSize: 10,
      };
      this.firstCompany.loading = true;
      const res = await userApi.queryInnerCompany(params);
      this.firstCompany.loading = false;
      if (res.success) {
        this.firstCompany.list = res.data.records;
      }
    },
    // 根据公司名称分页查询采购商(乙方)
    async queryPageByName(val) {
      const params = {
        companyName: val,
        pageNum: 1,
        pageSize: 10,
      };
      this.secondCompany.loading = true;
      const res = await userApi.getQuerySupplier(params);
      this.secondCompany.loading = false;
      if (res.success) {
        this.secondCompany.list = res.data.records;
      }
    },
    // 获取物料分类
    async queryShareAgreementCategoryTree(id) {
      const res = await agreementApi.queryShareAgreementCategoryTree(id);
      if (res.success) {
        this.treeData = res.data;
      }
    },

    firstChange(val) {
      this.firstCompany.list.map((item) => {
        if (val == item.companyId) {
          this.formData.firstCompanyName = item.companyName;
        }
      });
    },
    secondChange(val) {
      this.queryShareAgreementCategoryTree(val);
      this.secondCompany.list.map((item) => {
        if (val == item.companyId) {
          this.formData.secondCompanyName = item.companyName;
        }
      });
    },
    // 上传文件格式一律转为小写
    commonHandleCheck(val) {
      let testmsg = val.substring(val.lastIndexOf('.') + 1);
      testmsg && (testmsg = testmsg.toLowerCase());
      return testmsg;
    },
    // 上传之前图片验证
    beforeUpload(file) {
      const fileType = `.${this.commonHandleCheck(file.name)}`;
      const acceptList = this.acceptFileType.split(',');
      let nameOk = false;
      if (acceptList.includes(fileType)) {
        nameOk = true;
      } else {
        this.$message.error(`文件格式仅支持Word、Excel、PDF`);
        return false;
      }

      this.uploadData.name = this.formData.fileName;
      const isImageSize = file.size / 1024 / 1024 < 10;
      if (!isImageSize) {
        this.$message.error(`上传文件大小不能超过10MB!`);
        return false;
      }
      return isImageSize && nameOk;
    },
    handleSuccess(res) {
      if (res.code == 200) {
        this.formData.fileName = '';
        this.$message({ type: 'success', message: '上传附件成功！' });
        this.fileList.push({
          attachmentName: res.data.fileName,
          attachmentPath: res.data.url,
          uploadTime: res.data.uploadTime,
        });
      }
    },
    handleError(res) {
      console.log('error==>', res);
    },

    // 关闭-附件列表弹框
    accessoryResetPopupData() {
      this.accessoryVisiblel = false;
    },
    // 查看附件-下载
    handleDownloadAccessory(row) {
      window.open(row.attachmentPath, '_blank');
    },
    handleSubmit() {
      this.rules.fileName[0].required = false;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.selectedData.length == 0) {
            this.$message({ type: 'error', message: '请选择物料分类！' });
            return;
          }
          if (this.fileList.length == 0) {
            this.$message({ type: 'error', message: '请上传附件！' });
            return;
          }
          this.handleEdit();
        } else {
          this.rules.fileName[0].required = true;
          return false;
        }
      });
    },
    async handleEdit() {
      const params = { ...this.formData };
      params.attachments = this.fileList;
      params.agreementId = this.agreementId;
      const arr = [];
      this.selectedData.map((item) => {
        arr.push({
          categoryId: item.categoryId,
          categoryName: item.categoryName,
        });
      });
      params.categories = arr;

      const res = await agreementApi.modifyAgreement(params);
      if (res.success) {
        this.$message({ type: 'success', message: '调整协议成功！' });
        this.goback();
        bus.$emit('close_current_tags');
      }
    },
    goback() {
      this.$router.push('/sharedResourceAgreementManage');
    },

    /// //编辑
    // 获取协议详情
    async getAgreementInfo() {
      const res = await agreementApi.getSharedAgreementDetail({
        agreementId: this.agreementId,
      });
      if (res.success) {
        // 编辑情况下 已失效、已停用不能编辑
        // 协议状态（1-待生效 2-已生效 3-已失效  5-已停用）
        const statusArr = [3, 5];
        if (
          this.pageType == 'edit' &&
          statusArr.includes(res.data.agreementStatus)
        ) {
          this.handleEditStatus = true;
        }

        this.agreementStatus = res.data.agreementStatus;
        this.formData.agreementCode = res.data.agreementCode;
        this.formData.agreementName = res.data.agreementName;
        this.formData.agreementName = res.data.agreementName;
        this.formData.firstCompanyId = res.data.firstCompanyId;
        this.formData.firstCompanyName = res.data.firstCompanyName;
        this.firstCompany.list = [
          {
            companyId: res.data.firstCompanyId,
            companyName: res.data.firstCompanyName,
          },
        ];
        this.formData.secondCompanyId = res.data.secondCompanyId;
        this.formData.secondCompanyName = res.data.secondCompanyName;
        this.secondCompany.list = [
          {
            companyId: res.data.secondCompanyId,
            companyName: res.data.secondCompanyName,
          },
        ];
        this.queryShareAgreementCategoryTree(res.data.secondCompanyId);
        this.formData.secondCompanySource = res.data.secondCompanySource;
        this.formData.secondCompanyType = res.data.secondCompanyType;
        this.formData.startDate = res.data.startDate;
        this.formData.secondCompanySource = res.data.secondCompanySource;
        this.formData.serviceRate = res.data.serviceRate;
        this.formData.agreementStatus = res.data.agreementStatus;
        this.formData.auditStatus = res.data.auditStatus;
        this.formData.contact = res.data.contact;
        this.formData.telephone = res.data.telephone;
        this.selectedData = res.data.categories;
        const arr = [];
        res.data.categories.map((item) => {
          arr.push(item.categoryId);
        });
        this.defaultChecked = arr;
        res.data.attachments.forEach((item) => {
          item.uploadTime = item.attachmentUploadTime;
        });
        this.fileList = res.data.attachments;
      }
    },
    fileChange(file, fileList) {
      // console.log(file)
      // console.log(fileList)
      this.placeholderData.selectedFileName = file.name;
      this.selectedFile = file.raw;
      this.selectedFileList = fileList;
      this.$refs.ruleForm.clearValidate();
    },

    submitUpload() {
      this.$refs.ruleForm.validateField('fileName', (valid) => {
        if (!valid) {
          try {
            this.$refs.upload.submit();
          } catch (error) {
            console.log(error);
          }
        } else {
          return false;
        }
      });
    },
    uploadProcess(event) {
      this.progressFlag = true; // 显示进度条
      this.loadProgress = parseInt(event.percent); // 动态获取文件上传进度
      if (this.loadProgress >= 100) {
        this.loadProgress = 100;
        this.$set(this.placeholderData, 'selectedFileName', '浏览本地文件');
        console.log(
          ' this.selectedFileName',
          this.placeholderData.selectedFileName
        );

        setTimeout(() => {
          this.progressFlag = false;
        }, 1000); // 一秒后关闭进度条
      }
    },
    // 查询用户所属公司（默认取默认公司）
    async queryCompanyByMemberName(name) {
      const params = {
        memberName: name,
      };
      const res = await userApi.queryCompanyByMemberName(params);
      if (res.success && res.data) {
        this.formData.firstCompanyId = res.data.companyId;
        this.formData.firstCompanyName = res.data.companyName;
        this.firstCompany.list = [
          {
            companyId: res.data.companyId,
            companyName: res.data.companyName,
          },
        ];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container-box {
  padding: 12px;
  background: #fff;
  .form_wrapper {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    justify-content: center;
    .form_item {
      // flex:0 0 49%;
      .tree_box {
        p {
          line-height: 32px;
          height: 32px;
          border-bottom: 1px solid #e5e5e5;
          padding: 0 20px;
        }
        .search {
          display: flex;
          padding: 10px 10px 0 10px;
        }
        .searchText {
          margin-right: 8px;
        }
        width: 320px;
        height: 360px;
        border: 1px solid #e5e5e5;

        .tree {
          height: 270px;
          overflow-y: auto;
          margin: 10px;
          border: 1px solid #ececec;
          padding: 10px;
        }
        .selected {
          padding: 10px 20px;
          overflow-y: auto;
          height: 320px;
          li {
            display: flex;
            justify-content: space-between;
            span {
              display: inline-block;
            }
            .text {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .icon {
              cursor: pointer;
              width: 30px;
              height: 30px;
              text-align: center;
            }
          }
          .item_disabled {
            .text {
              color: #ccc;
            }
            .icon {
              color: #ccc;
              cursor: not-allowed;
            }
          }
        }
      }
    }
    .set-width {
      width: 40%;
    }
    .show-tip {
      font-size: 12px;
      color: #2f80ed;
    }
    .form_item_wrapper {
      // width: 80%;
      .line_box {
        // align-items: center;
        .box_tips {
          color: #409eff;
          cursor: pointer;
          //  margin-left: 50px;
          .tips_content {
            line-height: 32px;
          }
        }
      }
      .doc_list {
        color: #409eff;
        cursor: pointer;
        margin-left: 50px;
      }
    }
  }

  .tree_wrapper {
    .form_location {
      ::v-deep .el-form-item__label {
        line-height: 360px;
      }
    }
    .form_icon {
      position: relative;
      width: 120px;
      text-align: right;
      line-height: 360px;
      right: 0;
      color: #409eff;
      transform: translateX(20px);
      span {
        cursor: pointer;
      }
      i {
        font-weight: 700;
      }
    }
  }
  .form_item_wrapper {
    min-width: 980px;
    display: flex;
    .form_item_r {
      margin-left: 120px;
    }
  }
  .form_bottom {
    // width: 880px;
    text-align: center;
  }
}
</style>
